import {Component, EventEmitter, Input, Output} from '@angular/core';
import {ModalComponent} from '../modal-service.service';
import {NlrSanitizeResourcePipe} from '../../../pipe/nlr-sanitize-resource-pipe';

type ModalButton = {
    label: string;
    title?: string;
    action?: () => void;
    context?: string;
    btnClasses?: string;
};

export type CssClass = 'warning' | 'error' | 'info' | 'success';

@Component({
    selector: 'nlr-alert-modal',
    imports: [NlrSanitizeResourcePipe],
    templateUrl: './alert-modal.component.html',
    styleUrls: ['../modal.scss', './alert-modal.component.scss']
})
export class AlertModalComponent implements ModalComponent {
    @Input() alertModalTitle: string = 'Error message';
    @Input() alertModalMessages: string[] = [];

    @Input() alertFormValidationModalTitle: string = 'Validation Error message';
    @Input() alertFormValidationModalMessages: string[] = [];

    @Input() modalSize: 'sm' | 'md' | 'lg' = 'md';
    @Input() cssClass: CssClass = 'error';
    @Input() alertModalButtons: ModalButton[] = [
        {
            label: 'Cancel'
        }
    ];
    @Input() isDisabled = false;
    action: string = 'yes';

    // add output
    @Output() modalClosed: EventEmitter<string> = new EventEmitter<string>();

    constructor() {}

    hasAlertFormValidationModalMessages() {
        return this.alertFormValidationModalMessages?.length > 0;
    }

    setTitle(title: string) {
        this.alertModalTitle = title;
    }

    initCssClass(cssClass: CssClass): void {
        this.cssClass = cssClass;
    }

    addMessage(summary, detail?): void {
        // if (summary === undefined || detail === undefined) {
        //     return;
        // }

        const summaryMsg = summary ? (summary.errorMessage ? summary.errorMessage : summary) : '';
        const detailMsg = detail ? (detail.errorMessage ? detail.errorMessage : detail) : undefined;
        const msg = `${summaryMsg}${detailMsg ? '. ' + detailMsg : ''}`;

        this.alertModalMessages.push(msg);
    }

    addFormValidationMessages(messages: string[], title?: string): void {
        // copied from old code. the logic is very wiered.
        this.alertFormValidationModalTitle =
            title || 'The form is invalid. Please action all the required fields described below and highlighted on the form before proceeding.';

        // copied from old code. the logic is very wiered.
        this.alertFormValidationModalMessages = messages;
        // return this.alertFormValidationModalMessages;
    }

    initButtons(label: string, action?, context?, btnClasses?, tooltip?) {
        // copied from old code. the logic is very wiered.
        this.alertModalButtons = [];
        this.addButton(label, action, context, btnClasses, tooltip);
    }

    addButton(label: string, action: () => void, context: string, btnClasses: string, tooltip: string) {
        // this.checkInitialise();

        this.alertModalButtons.push({
            label: label,
            title: tooltip,
            action: action,
            context: context,
            btnClasses: btnClasses
        });
    }

    isAlertModalHasValidParameters(): boolean {
        console.debug('this.alertModalMessages = ', this.alertModalMessages);
        console.debug('this.alertFormValidationModalMessages =', this.alertFormValidationModalMessages);
        console.debug('this.alertFormValidationModalMessages.length =', this.alertFormValidationModalMessages.length);
        if (this.alertModalMessages.length == 0) {
            console.debug('No alertModalMessages.');
        }
        if (this.alertFormValidationModalMessages.length === 0) {
            console.debug('No alertFormValidationModalMessages.');
        }
        return !(
            this.alertModalMessages.length === 0 &&
            (this.alertFormValidationModalMessages === undefined || this.alertFormValidationModalMessages.length === 0)
        );
    }

    // emit on click
    remove(): void {
        this.modalClosed.emit('remove element');
    }

    buttonSelected(button: ModalButton) {
        if (this.isDisabled) {
            return;
        }
        this.isDisabled = true;
        if (button.action) {
            setTimeout(button.action, 0);
        }
        this.modalClosed.emit(this.action);
    }
}
